import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Cake, Award } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Avatar } from "./StaffAvatar";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const SetBirthday = ({ onDone }) => {
  const [m, setM] = useState("");
  const [d, setD] = useState("");
  const save = () => api.put("/me/birthday", { birthday: `${m}-${d}` }).then(() => { toast.success("Birthday saved. Only the day and month are kept."); onDone(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground" data-testid="home-set-birthday">
      <Cake className="h-3.5 w-3.5 text-primary" /> Add your birthday so the team can wish you:
      <select data-testid="birthday-month" value={m} onChange={(e) => setM(e.target.value)} className="border h-7 px-1 bg-white"><option value="">Month</option>{MONTHS.map((x, i) => <option key={x} value={String(i + 1).padStart(2, "0")}>{x}</option>)}</select>
      <select data-testid="birthday-day" value={d} onChange={(e) => setD(e.target.value)} className="border h-7 px-1 bg-white"><option value="">Day</option>{Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, "0")).map((x) => <option key={x}>{x}</option>)}</select>
      <button data-testid="birthday-save" disabled={!m || !d} onClick={save} className="border border-primary text-primary h-7 px-2 rounded-lg disabled:opacity-40">Save</button>
    </div>
  );
};

export const Birthdays = () => {
  const { user, refresh } = useAuth();
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/team/birthdays").then((r) => setList(r.data)).catch(() => {}); }, []);
  const bdays = list.filter((b) => b.kind !== "anniversary");
  const annis = list.filter((b) => b.kind === "anniversary");
  const me = bdays.find((b) => b.is_me);
  const others = bdays.filter((b) => !b.is_me);
  const myAnni = annis.find((b) => b.is_me);
  const otherAnnis = annis.filter((b) => !b.is_me);
  const yrs = (n) => `${n} year${n === 1 ? "" : "s"}`;
  return (
    <div className="space-y-3 mb-6">
      {me && <div data-testid="home-birthday-me" className="rounded-2xl p-4 flex items-center gap-3" style={{ background: "linear-gradient(120deg, #ffe9f0, #fff4d6)" }}>
        <Cake className="h-5 w-5 text-primary" /><span className="font-medium">Happy birthday, {me.name}! Wishing you a wonderful year ahead from everyone at Axiom.</span></div>}
      {others.length > 0 && <div data-testid="home-birthday-team" className="rounded-2xl p-4 flex flex-wrap items-center gap-3" style={{ background: "linear-gradient(120deg, #fff4d6, #ecf8f3)" }}>
        <Cake className="h-5 w-5 text-primary" />
        <span className="font-medium">Happy birthday to</span>
        {others.map((b) => <span key={b.name} className="inline-flex items-center gap-1.5 bg-white/70 rounded-full pl-1 pr-3 py-0.5" data-testid={`home-birthday-${b.name}`}><Avatar name={b.staff_name} size={22} />{b.name}</span>)}
        <span className="text-sm text-muted-foreground">Drop them a wish today.</span></div>}
      {myAnni && <div data-testid="home-anniversary-me" className="rounded-2xl p-4 flex items-center gap-3" style={{ background: "linear-gradient(120deg, #ece7ff, #e0f0fb)" }}>
        <Award className="h-5 w-5 text-primary" /><span className="font-medium">Happy work anniversary, {myAnni.name}! {yrs(myAnni.years)} with Axiom. Thank you for everything.</span></div>}
      {otherAnnis.length > 0 && <div data-testid="home-anniversary-team" className="rounded-2xl p-4 flex flex-wrap items-center gap-3" style={{ background: "linear-gradient(120deg, #e0f0fb, #ecf8f3)" }}>
        <Award className="h-5 w-5 text-primary" /><span className="font-medium">Work anniversary</span>
        {otherAnnis.map((b) => <span key={b.name} className="inline-flex items-center gap-1.5 bg-white/70 rounded-full pl-1 pr-3 py-0.5" data-testid={`home-anniversary-${b.name}`}><Avatar name={b.staff_name} size={22} />{b.name} · {yrs(b.years)} with Axiom</span>)}
        <span className="text-sm text-muted-foreground">Say congratulations today.</span></div>}
      {user && !user.birthday && <SetBirthday onDone={refresh} />}
    </div>
  );
};
